import CustomInput from "../../../components/CustomInput";
import SubHeadings from "../../../components/SubHeadings";
import { Student } from "../../../types/studentType";
import { IS_LIVE } from "../../../util/config/env";
import { useFormEdit } from "../../../util/hooks/useFormEdit";

interface otherInformationProps {
  form: ReturnType<typeof useFormEdit<Student>>;
}

export default function OtherAdmissionDetails({ form }: otherInformationProps) {
  const { formData, setFormData, isEditing } = form;

  const handleInputChange = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const { name, value, type, checked } = event.target as HTMLInputElement;

    let newValue: any = value;

    if (type === "radio") {
      newValue = value === "true";
    }

    if (type === "checkbox") {
      newValue = checked;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  return (
    <div className="flex flex-col gap-7 py-7 px-4 md:px-9">
      <div className="flex justify-between items-center">
        <SubHeadings text="Other Details" />
      </div>
      <form className="flex flex-col gap-7">
        {IS_LIVE && (
          <div className="grid md:grid-cols-2 gap-7">
            <CustomInput
              name="bloodGroup"
              label="Blood Group"
              readOnly={!isEditing}
              type="text"
              placeholder="Ex: O+"
              value={formData.bloodGroup ?? ""}
              onChange={handleInputChange}
              inputClassName="w-full"
            />

            <CustomInput
              name="allergies"
              label="Allergies (if any)"
              type="text"
              readOnly={!isEditing}
              placeholder="Please mention Allergies (if any)"
              value={formData.allergies ?? ""}
              onChange={handleInputChange}
              inputClassName="w-full"
              className="lg:w-full"
            />
          </div>
        )}
        <div className="flex flex-col md:flex-row gap-7">
          <div className="md:w-[30%]">
            <CustomInput
              name="nationality"
              label="Nationality"
              readOnly={!isEditing}
              placeholder="Enter nationality"
              value={formData.nationality ?? ""}
              onChange={handleInputChange}
              inputClassName="w-full"
            />
          </div>

          <CustomInput
            name="specialInstructions"
            label="Any special instructions"
            type="text"
            readOnly={!isEditing}
            placeholder="Please mention any specific instructions for your child"
            value={formData.specialInstructions ?? ""}
            onChange={handleInputChange}
            inputClassName="w-full"
          />
        </div>
        <div className="flex flex-col md:flex-row gap-7  md:items-center text-nowrap">
          <label className="text-sm font-semibold text-neutral-400 block">
            Transport facility required?
          </label>
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <CustomInput
                name="transportRequired"
                type="radio"
                checked={formData.transportRequired === true}
                value="true"
                onChange={handleInputChange}
                disabled={!isEditing}
                inputClassName="w-3 h-3"
              />
              <span
                className={`text-sm font-semibold ${
                  formData.transportRequired === true
                    ? "text-primary-500"
                    : "text-neutral-300"
                }`}
              >
                Yes
              </span>
            </div>

            <div className="flex items-center gap-2">
              <CustomInput
                name="transportRequired"
                type="radio"
                checked={formData.transportRequired === false}
                value="false"
                onChange={handleInputChange}
                disabled={!isEditing}
                inputClassName="w-3 h-3"
              />
              <span
                className={`text-sm font-semibold ${
                  formData.transportRequired === false
                    ? "text-primary-500"
                    : "text-neutral-300"
                }`}
              >
                No
              </span>
            </div>
          </div>
        </div>
        <div className="flex items-center mt-10 gap-2">
          <input
            type="checkbox"
            name="termsAccepted"
            checked={!!formData.termsAccepted}
            onChange={handleInputChange}
            disabled={!isEditing}
            className="w-3 h-3"
          />

          <span className="text-sm font-semibold text-neutral-400">
            By clicking, I agree to the terms and conditions of the school as
            per the school policy
          </span>
        </div>
      </form>
    </div>
  );
}
